import { render, staticRenderFns } from "./BotManageIntegration.vue?vue&type=template&id=d22e92be&"
import script from "./BotManageIntegration.vue?vue&type=script&lang=js&"
export * from "./BotManageIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports